import { useState } from "react"

import { Notice } from "../../../../shared/components"
import { MAX_FRAMES } from "../../../config"

const LONG_LOOP_MS = 8000

interface Props {
  // Frames left out by the frame cap so far; the count grows when added frames overflow it.
  droppedFrames: number
  loopMs: number
}

export const AnimationNotices = ({ droppedFrames, loopMs }: Props) => {
  // Dropped frames the visitor has already dismissed a notice about.
  const [acknowledgedDrops, setAcknowledgedDrops] = useState(0)
  const [isLongLoopDismissed, setIsLongLoopDismissed] = useState(false)
  const newDrops = droppedFrames - acknowledgedDrops

  return (
    <>
      {newDrops > 0 && (
        <Notice tone="warning" onDismiss={() => setAcknowledgedDrops(droppedFrames)}>
          Kept the first {MAX_FRAMES} frames and dropped {newDrops} — that&apos;s the cap for a
          cursor.
        </Notice>
      )}
      {loopMs > LONG_LOOP_MS && !isLongLoopDismissed && (
        <Notice tone="warning" onDismiss={() => setIsLongLoopDismissed(true)}>
          One loop takes {(loopMs / 1000).toFixed(1)} s — long loops feel laggy as a cursor. Speed
          it up or drop frames.
        </Notice>
      )}
    </>
  )
}
